import styled from 'styled-components';

const State = styled.div`
  width: 100%;
  position: relative;
`;

export default State;
